const initial_state = {
  logged_in: false,
  login_started: false,
  login_failed: false,
  social_auth: false,
  social: '',
  api_token: 'HOhjYf8ZRwWg0IyC5OkH7Y3ssQBAe0laXi1siwcKgMFxJUWkFkW1eqbiTybL',
  visible_name: '',
  links: [],
  avatar: ''
}

const user = (state = initial_state, action) => {
  switch (action.type) {
    case 'SOCIAL_AUTH_START':
      return Object.assign({}, state, {
        login_started: true,
      })
    case 'SOCIAL_AUTH_SUCCESS':
      return Object.assign({}, state, {
        social_auth: true,
        social: action.user,
        visible_name: action.user.name,
        avatar: action.user.picture.data.url,
      })
    case 'SOCIAL_AUTH_FAILED':
      return Object.assign({}, state, {
        login_started: false,
        login_failed: true,
      })
    case 'AUTH_SUCCESS':
      window.localStorage.setItem('user_social', JSON.stringify(action.response));
      window.localStorage.setItem('logged_in', true);

      console.log(action.user)
      return Object.assign({}, state, {
        logged_in: true,
        login_started: false,
        api_token: action.user.api_token,
        links: [
            ...action.user.links
          ],
      })
    case 'AUTH_FAILED':
      return Object.assign({}, state, {
        logged_in: false,
        login_started: false,
        login_failed: true,
        visible_name: '',
        links: '',
      })
    case 'AUTH_LOGOUT':
      window.localStorage.removeItem('user_social');
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('logged_in');

      return Object.assign({}, state, {
        logged_in: false,
        login_started: false,
        login_failed: false,
        social_auth: false,
        social: '',
        api_token: 'HOhjYf8ZRwWg0IyC5OkH7Y3ssQBAe0laXi1siwcKgMFxJUWkFkW1eqbiTybL',
        visible_name: '',
        links: [],
        avatar: ''
      })
    case 'SHORTEN_SUCCESS':
      return {
        ...state,
        links: [
            ...state.links,
            action.response
        ]
      }

    default:
      return state
  }
}

export default user;




// WEBPACK FOOTER //
// ./src/reducers/user.js